define('headerUserEditView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'settings',  
  'dialogFormView',
  'imageUtils',
  'template!headerUserEditView',
  'entities/caccounts/userpids',
  'entities/caccounts/config'
], function(
  App,
  Module,
  _,
  $,
  Settings,  
  DialogFormView,
  ImageUtils,
  Tpl
) {
  'use strict';

  Module.exports = DialogFormView.extend({
    template: Tpl,
    className: 'header-user-edit-view', 

    ui: {
      upload: '.upload-user-avatar',
      preview: '.user-avatar-img',
      save: '.btn-s-md-save',
      input: '.js-form-input',
      changePassword: '.js-change-password',
      notificationsEnabled: '.notificationsEnabled',
      availableList: '.available-list',
      selectedList: '.selected-list',
      addLanguage: '.add-language',
      removeLanguage: '.remove-language',
      moveUp: '.move-up',
      moveDown: '.move-down'
    },

    events: {
      'change @ui.input': 'onInputChange',
      'focus @ui.input': 'onFocus',
      'change .checkbox-input': 'onChangeCheckboxInput',
      'click @ui.changePassword': 'onChangePassword',
      'click @ui.save': 'onSave', 
      'change @ui.upload' : 'onChangeLogo',
      'click @ui.addLanguage': 'onAddLanguage',
      'click @ui.removeLanguage': 'onRemoveLanguage',
      'click @ui.moveUp': 'onMoveUp',
      'click @ui.moveDown': 'onMoveDown',
      'click .language-list li': 'onSelectLanguageItem'
    },

    initialize: function() {
      this.formData = new FormData();
      this.availableLanguages = this.getAvailableLanguages();
      this.preferredLanguages = this.getPreferredLanguages();
    },

    getAvailableLanguages: function() {
      var webshops = Settings.getWebshopLocales();
      var languageMap = {};
      
      _.each(webshops, function(webshop) {
        var langCode = webshop.code.split('_')[0];
        if (langCode && !languageMap[langCode]) {
          languageMap[langCode] = {
            code: langCode,
            label: langCode.toUpperCase()
          };
        }
      });
      
      return _.values(languageMap);
    },

    getPreferredLanguages: function() {
      var cAccountConfig = Settings.get('cAccountConfig');
      if (cAccountConfig) {
        var userData = cAccountConfig.get('userData');
        if (userData && userData.get('preferredLanguages')) {
          return userData.get('preferredLanguages').slice();
        }
      }
      return [];
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      if (templateData.notificationsEnabled === undefined)
        templateData.notificationsEnabled = true;

      if (this.model.get('logo'))
        templateData.fileUrl =
            Settings.url('file', this.model.get('logo'), {size: 'thumbnail'});
      else
        templateData.fileUrl = null;

      // Only show preferredLanguages if advancedMode is enabled
      if (Settings.configValue('advancedMode') === true) {
        templateData.availableLanguages = this.availableLanguages;
        templateData.preferredLanguages = this.preferredLanguages;
      } else {
        templateData.availableLanguages = [];
        templateData.preferredLanguages = [];
      }
      
      return templateData;
    },

    onChangeCheckboxInput: function () {       
      this.triggerMethod('enable:cancel:confirm');
    },    

    onChangePassword: function() {    
      var model = App.request('session:change:password');

      model.save({}, {
        success: _.bind(function(model, response) {
          this.hide();
          App.navigate('reset_password' + '?tokenfp=' + response.value, {trigger: true});
        }, this),
        error: _.bind(function() {
          //this.onShowMessage('danger', _.i18n('common.request.error'));
        }, this)
      });
    },

    onSave: function() {     

      var fieldsToValidate = [
        {name: 'firstName', type: 'required'},
        {name: 'lastName', type: 'required'}
      ];

      if (this.validate(fieldsToValidate)) {
        this.formData.append('secId', this.model.get('secId'));
        this.formData.append('firstName', this.model.get('firstName'));
        this.formData.append('lastName', this.model.get('lastName'));
        this.formData.append('notificationsEnabled', this.ui.notificationsEnabled.is(':checked'));

        var postRequest = App.request('caccount-admins:post-item', this.formData);
        postRequest.done(_.bind(function(data) {
          Settings.set('currentUserCookie', JSON.stringify(data));
          Settings.set('currentUser', data);

          // Save preferred languages if available
          if (this.availableLanguages && this.availableLanguages.length > 0) {
            this.savePreferredLanguages();
          }

          if(this.options.saved) {
            this.options.saved();
          }
          
          this.hide();
        }, this));
      }
    },

    savePreferredLanguages: function() {
      var selectedLanguages = this.getSelectedLanguagesFromUI();
      var cAccountConfig = Settings.get('cAccountConfig');
      
      if (cAccountConfig) {
        var userData = cAccountConfig.get('userData');
        if (userData) {
          userData.set('preferredLanguages', selectedLanguages);
          userData.save();
        }
      }
    },

    getSelectedLanguagesFromUI: function() {
      var languages = [];
      this.ui.selectedList.find('li').each(function() {
        languages.push($(this).data('code'));
      });
      return languages;
    },

    onChangeLogo: function() {
      var file = this.ui.upload[0].files[0];
      this.formData.append('file', file);
      ImageUtils.encodeFileToBase64(file, _.bind(this.previewFile, this));      
    },

    previewFile: function(base64File) {
      this.ui.preview.attr('style', 'background-image: url(' + base64File + ')');
    },

    onSelectLanguageItem: function(e) {
      var $item = $(e.currentTarget);
      $item.closest('.language-list').find('li').removeClass('selected');
      $item.addClass('selected');
      this.triggerMethod('enable:cancel:confirm');
    },

    onAddLanguage: function() {
      var $selected = this.ui.availableList.find('li.selected');
      if ($selected.length > 0) {
        $selected.removeClass('selected');
        this.ui.selectedList.append($selected);
        this.triggerMethod('enable:cancel:confirm');
      }
    },

    onRemoveLanguage: function() {
      var $selected = this.ui.selectedList.find('li.selected');
      if ($selected.length > 0) {
        $selected.removeClass('selected');
        this.ui.availableList.append($selected);
        this.triggerMethod('enable:cancel:confirm');
      }
    },

    onMoveUp: function() {
      var $selected = this.ui.selectedList.find('li.selected');
      if ($selected.length > 0 && $selected.prev().length > 0) {
        $selected.insertBefore($selected.prev());
        this.triggerMethod('enable:cancel:confirm');
      }
    },

    onMoveDown: function() {
      var $selected = this.ui.selectedList.find('li.selected');
      if ($selected.length > 0 && $selected.next().length > 0) {
        $selected.insertAfter($selected.next());
        this.triggerMethod('enable:cancel:confirm');
      }
    }
  });
});
